export { default as Bats } from './component'
